export const transformData = (key: string, data: any): any => {
  // Check if data and data.data exist and if data.data is an array
  if (data && Array.isArray(data.data)) {
    const transformedData = data.data.map((item: any) => item.attributes);
    return transformedData;
  }
  return data;
};
